import store from '../../store';
import Errors from '../../Errors';
import CartHelpersMixin from '../../mixins/CartHelpersMixin';
import ProductHelpersMixin from '../../mixins/ProductHelpersMixin';

export default {
    mixins: [
        CartHelpersMixin,
        ProductHelpersMixin,
    ],

    props: ['customerEmail', 'customerPhone', 'gateways', 'defaultAddress', 'addresses', 'countries','region'],

    data() {
        return {
            userAddresses: this.addresses,
            iti: null,
            loadingPaymentBlock : false,
            loadingCityField : false,
            isLoggedIn : FleetCart.loggedIn,
            savingAddress: false,
            cities: {},
            /*areas: {},*/
            selectedBillingAddress: null,
            selectedShippingAddress: null,
            form: {
                customer_email: this.customerEmail,
                customer_phone: this.customerPhone,
                billing: {
                    country:0,
                    city:0,
                    address_id:0,
                },
                shipping: {
                    country:0,
                    city:0,
                    address_id:0,
                },
                billingAddressId: null,
                shippingAddressId: null,
                newBillingAddress: false,
                newShippingAddress: false,
                isGuest: false,
                payment_method: false
            },           
            placingOrder: false,
            errors: new Errors(),
            stripe: null,
            stripeCardElement: null,
            stripeError: null,
            payfort: null,
            payfortCardElement: null,
            payfortError: null,
            newGuestAddressAdded:false,
            selectedAddress:false,
        };
    },

    computed: {
        citiesComputed(){
            return this.cities;
        },

        /*
        areasComputed(){
            return this.areas;
        },
        */

        hasAddress() {
            return Object.keys(this.addresses).length !== 0;
        },

        hasSelectedAddress() {
            return this.selectedAddress;
        },

        guestAddressAdded() {
            if(this.newGuestAddressAdded)
                return true;
        },

        firstCountry() {
            return Object.keys(this.countries)[0];
        },

        firstCity() {
            return Object.keys(this.cities)[0];
        },

        /*        
        firstArea() {
            return Object.keys(this.areas)[0];
        },
        */

        hasNoPaymentMethod() {
            return Object.keys(this.gateways).length === 0;
        },

        hasSelectedPaymentMethod() {
            return this.form.payment_method;
        },

        hasSelectedShippingMethod() {
            return this.form.shipping_method;
        },

        firstPaymentMethod() {
            return Object.keys(this.gateways)[0];
        },

        shouldShowPaymentInstructions() {
            return ['bank_transfer', 'check_payment'].includes(this.form.payment_method);
        },

        paymentInstructions() {
            if (this.shouldShowPaymentInstructions) {
                return this.gateways[this.form.payment_method].instructions;
            }
        },
    },
    mounted() {
        const input = document.querySelector(".intl-phone");
        let initialCountryVal = $("#billing-phone-iso").val() ? $("#billing-phone-iso").val() : FleetCart.currentCountryCode;  
        this.iti = window.intlTelInput(input, {
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js",
            excludeCountries: ["il"],
            initialCountry: initialCountryVal,
            formatOnDisplay: true,
            nationalMode: true,
            autoHideDialCode: false,
            placeholderNumberType: "MOBILE",
            preferredCountries: ['ae','sa','bh','kw','om','qa','eg','jo','lb'],
        });

        input.addEventListener("countrychange", () => {
            const selectedCountryData = this.iti.getSelectedCountryData();
            $("#billing-phone-extension").val(selectedCountryData.dialCode);
            $("#billing-phone-iso").val(selectedCountryData.iso2);
        });

        //this.setDefaultBillingAddress();
    },
    watch: {
        addresses(newAddresses) {
            this.userAddresses = newAddresses;
        },
        
        selectedBillingAddress: function(newVal) {
            if(!this.form.ship_to_a_different_address){
                this.selectedAddress = newVal.id
                this.form.billingAddressId = newVal.id;
                newVal.phone_iso = newVal.phone_iso ? newVal.phone_iso : FleetCart.currentCountryCode;
                this.iti.setCountry(newVal.phone_iso);
                $("#collapseShippingMethodBtn").prop("disabled",false).click()
                
                this.mergeSavedAddresses();
                this.$delete(this.form, 'shipping_method');
                this.updateShippingFees();
            }
        },

        selectedShippingAddress: function(newVal) {
            this.selectedAddress = newVal.id
            this.form.shippingAddressId = newVal.id;
            newVal.phone_iso = newVal.phone_iso ? newVal.phone_iso : FleetCart.currentCountryCode;
            this.iti.setCountry(newVal.phone_iso);

            $("#collapseShippingMethodBtn").prop("disabled",false).click()
        },
             
        'form.billingAddressId': function () {
            if(!this.form.ship_to_a_different_address){
                this.selectedAddress = this.form.billingAddressId
            }
        },

        'form.shippingAddressId': function () {
            if(this.form.ship_to_a_different_address){
                this.selectedAddress = this.form.shippingAddressId
                this.mergeSavedAddresses();
                this.$delete(this.form, 'shipping_method');
            }  
        },

        'form.ship_to_a_different_address': function () {
        },

        'form.shipping_method': function (newShippingMethod) {
        },

        'form.payment_method': function (newPaymentMethod) {
            if (newPaymentMethod === 'paypal') {
                this.$nextTick(this.renderPayPalButton);
            }

            if (newPaymentMethod !== 'stripe') {
                this.stripeError = '';
            }

            if (newPaymentMethod !== 'payfort') {
                this.payfortError = '';
            }
        },
    },

    created() {
        if (this.defaultAddress.address_id) {
            //this.form.billingAddressId = this.defaultAddress.address_id;
            //this.form.shippingAddressId = this.defaultAddress.address_id;
            //this.mergeSavedAddresses();
        }

        if (! this.hasAddress) {
            this.form.newBillingAddress = true;
            this.form.newShippingAddress = true;
        }

        this.$nextTick(() => {
            if(Object.keys(this.addresses).length >= 1 && FleetCart.loggedIn){
                let firstAddress = this.addresses[Object.keys(this.addresses)[0]];
                //this.syncShippingAddress(firstAddress);
            }

            if (window.Stripe) {
                this.stripe = window.Stripe(FleetCart.stripePublishableKey);

                this.renderStripeElements();
            }
        });
    },

    methods: {
        /*setDefaultBillingAddress() {
            const addressArray = Object.values(this.addresses); // Convert the object into an array
            const defaultAddress = addressArray.find(address => address.is_default);
            if (defaultAddress) {
                this.selectedBillingAddress = { id: defaultAddress.id, phone_iso: defaultAddress.phone_iso };
            }
        },*/
        saveBillingAddress() {
            this.savingAddress = true;

            $.ajax({
                method: 'PATCH',
                url: route('checkout.billing-address.save'),
                data: $("#checkout-form").serialize()
            }).then((fetchedData) => {
                if(fetchedData.address){
                    this.selectedBillingAddress = { country: fetchedData.address.country, id: fetchedData.address.id, phone_iso: fetchedData.address.phone_iso };
                    this.selectedAddress = fetchedData.address.id
                    $("#billing_full_name_"+fetchedData.address.id).text(fetchedData.address.full_name)
                    $("#billing_address_1_"+fetchedData.address.id).text(fetchedData.address.address_1)
                    $("#billing_country_"+fetchedData.address.id).text(fetchedData.address.country_name)

                    this.$set(this.form.billing, 'first_name', fetchedData.address.first_name);
                    this.$set(this.form.billing, 'last_name', fetchedData.address.last_name);
                    this.$set(this.form.billing, 'email', fetchedData.address.email);
                    this.$set(this.form.billing, 'phone', fetchedData.address.phone);
                    this.$set(this.form.billing, 'phone_extension', fetchedData.address.phone_extension);
                    this.$set(this.form.billing, 'phone_iso', fetchedData.address.phone_iso);
                    this.$set(this.form.billing, 'city', fetchedData.address.city);
                    this.$set(this.form.billing, 'country', fetchedData.address.country);
                    this.$set(this.form.billing, 'country_name', fetchedData.address.country_name);
                    this.$set(this.form.billing, 'address_1', fetchedData.address.address_1);
                    this.$set(this.form.billing, 'address_2', fetchedData.address.address_2);
                    this.$set(this.form.billing, 'zip', fetchedData.address.zip);
                    this.$set(this.form.billing, 'address_id', fetchedData.address.id);
                }
                else if(this.form.isGuest){
                    $("#collapseShippingMethodBtn").prop("disabled",false).click()
                    this.selectedAddress = 1 // hard-coded
                    this.newGuestAddressAdded = true;
                    this.updateShippingFees();
                }

                if(fetchedData.addresses){
                    this.userAddresses = fetchedData.addresses;
                }

                this.form.newBillingAddress = false;

                this.form.editBillingAddress = false;

                if(fetchedData.address){
                    this.syncShippingAddress(fetchedData.address);
                    $("#collapseShippingMethodBtn").prop("disabled",false).click()
                }
                
                //store.updateCart(fetchedData.cart);

                this.savingAddress = false;
                this.$notify(this.$trans('storefront::layout.saved_successfully'));

            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                    $('html, body').animate({
                        scrollTop: $('#billing-first-name').offset().top-120
                    }, 800);
                }
                this.$notify(xhr.responseJSON.message);
                this.savingAddress = false;
            });
        },
        
        saveShippingAddress() {
            this.savingAddress = true;
            $.ajax({
                method: 'POST',
                url: route('checkout.shipping-address.save'),
                data: $("#checkout-form").serialize()
            }).then((fetchedData) => {
                if(fetchedData.address){
                    this.selectedShippingAddress = { country: fetchedData.address.country, id: fetchedData.address.id, phone_iso: fetchedData.address.phone_iso };
                    this.selectedAddress = fetchedData.address.id
                    $("#shipping_full_name_"+fetchedData.address.id).text(fetchedData.address.full_name)
                    $("#shipping_address_1_"+fetchedData.address.id).text(fetchedData.address.address_1)
                    $("#shipping_country_"+fetchedData.address.id).text(fetchedData.address.country_name)

                    this.$set(this.form.shipping, 'first_name', fetchedData.address.first_name);
                    this.$set(this.form.shipping, 'last_name', fetchedData.address.last_name);
                    this.$set(this.form.shipping, 'phone', fetchedData.address.phone);
                    this.$set(this.form.shipping, 'email', fetchedData.address.email);
                    this.$set(this.form.shipping, 'phone_extension', fetchedData.address.phone_extension);
                    this.$set(this.form.shipping, 'phone_iso', fetchedData.address.phone_iso);
                    this.$set(this.form.shipping, 'city', fetchedData.address.city);
                    this.$set(this.form.shipping, 'country', fetchedData.address.country);
                    this.$set(this.form.shipping, 'address_1', fetchedData.address.address_1);
                    this.$set(this.form.shipping, 'address_2', fetchedData.address.address_2);
                    this.$set(this.form.shipping, 'zip', fetchedData.address.zip);
                    this.$set(this.form.shipping, 'address_id', fetchedData.address.id);
                }
                else if(this.form.isGuest){
                    $("#collapseShippingMethodBtn").prop("disabled",false).click()
                    this.selectedAddress = 1 // hard-coded
                    this.newGuestAddressAdded = true;
                    this.updateShippingFees();
                }


                if(fetchedData.addresses){
                    this.userAddresses = fetchedData.addresses;
                }

                this.form.newShippingAddress = false;

                if(fetchedData.address){
                    this.syncShippingAddress(fetchedData.address);
                    $("#collapseShippingMethodBtn").prop("disabled",false).click()
                }

                //store.updateCart(fetchedData.cart);

                this.$notify(this.$trans('storefront::layout.saved_successfully'));
                this.savingAddress = false;
                
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                    $('html, body').animate({
                        scrollTop: $('#shipping-first-name').offset().top-120
                    }, 800);
                }
                this.$notify(xhr.responseJSON.message);
                this.savingAddress = false;
            });

        },

        addNewBillingAddress() {

            $('html, body').animate({
                scrollTop: $('.add-new-address-billing').offset().top-160
            }, 800);

            this.errors.reset();

            this.resetBillingForm();

            //this.changeBillingCountry(this.region.id);

            this.form.newBillingAddress = ! this.form.newBillingAddress;
        },
        
        resetBillingForm() {
            this.form.billing = {
                    country:0,
                    city:0,
                    address_id:0,
            }
        },

        addNewShippingAddress() {
            
            $('html, body').animate({
                scrollTop: $('.add-new-address-shipping').offset().top-160
            }, 800);

            this.errors.reset();

            this.resetShippingForm();

            this.form.newShippingAddress = ! this.form.newShippingAddress;
        },

        resetShippingForm() {
            this.form.shipping = {
                    country:0,
                    city:0,
                    address_id:0,
            }
        },

        checkSignIn() {
            let errors = {};

            if(! this.form.customer_email)
            {
                this.$set(errors, 'customer_email', {0: trans('storefront::checkout.email_is_required')})
            }

            if(! this.form.customer_password)
            {
                this.$set(errors, 'customer_password', {0: trans('storefront::checkout.password_is_required')})
            }

            this.errors.record(errors);

            if(this.errors.any()) return false;

            this.signingIn = true;

            $.ajax({
                method: 'POST',
                url: route('login.post'),
                data: this.form,
            }).then((response) => {
                if (response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                }
                else if (response.status == 'error') {
                    let msgErr = response.message?response.message:'Error in username or password';
                    this.$notify(msgErr);
                }
                else if (response.status == 'success') {
                    location.reload();
                }
            }).catch((xhr) => {
                this.$sweetError('Error in username or password');

                this.signingIn = false;
            }).always(() => {
                this.signingIn = false;
            });
        },

        continueAsAguest() {
            this.form.isGuest = true;
            $("#collapseBillingBtn").prop("disabled",false).click()
        },

        syncShippingAddress(address) {
            this.form.newBillingAddress = false;
            this.form.billingAddressId = address.id;
            this.form.billing = address;
        },

        editBillingAddress(addressId) {
            this.errors.reset();
            $('html, body').animate({
                scrollTop: $('.add-new-address-billing').offset().top-160
            }, 800);

            $.ajax({
                method: 'GET',
                url: route('checkout.address', { addressId }),
            }).then((data) => {
                this.$set(this.form.billing, 'first_name', data.address.first_name);
                this.$set(this.form.billing, 'last_name', data.address.last_name);
                this.$set(this.form.billing, 'email', data.address.email);
                this.$set(this.form.billing, 'phone', data.address.phone);
                $("#billing-phone-extension").val(data.address.phone_extension)
                $("#billing-phone-iso").val(data.address.phone_iso)
                data.address.phone_iso = data.address.phone_iso ? data.address.phone_iso : FleetCart.currentCountryCode;
                this.iti.setCountry(data.address.phone_iso);
                this.$set(this.form.billing, 'address_1', data.address.address_1);
                this.$set(this.form.billing, 'zip', data.address.zip);
                this.$set(this.form.billing, 'address_id', data.address.id);
                this.changeBillingCountry(data.address.country, data.address.city);
                this.$set(this.form.billing, 'country', data.address.country);
                this.form.newBillingAddress = true;
                
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            });
        },

        editShippingAddress(addressId) {
            this.errors.reset();
            $('html, body').animate({
                            scrollTop: $('.add-new-address-shipping').offset().top-160
                        }, 800);
            $.ajax({
                method: 'GET',
                url: route('checkout.address', { addressId }),
            }).then((data) => {

                this.$set(this.form.shipping, 'first_name', data.address.first_name);
                this.$set(this.form.shipping, 'last_name', data.address.last_name);
                this.$set(this.form.shipping, 'email', data.address.email);
                this.$set(this.form.shipping, 'phone', data.address.phone);
                this.$set(this.form.shipping, 'phone_extension', data.address.phone_extension);
                this.$set(this.form.shipping, 'phone_iso', data.address.phone_iso);
                this.$set(this.form.shipping, 'country', data.address.country);
                this.$set(this.form.shipping, 'city', data.address.city);
                this.$set(this.form.shipping, 'address_1', data.address.address_1);
                this.$set(this.form.shipping, 'zip', data.address.zip);
                this.$set(this.form.shipping, 'address_id', data.address.id);
                this.changeShippingCountry(data.address.country, data.address.city);
                this.$set(this.form.shipping, 'country', data.address.country);
                this.form.newShippingAddress = true;
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            });
        },

        mergeSavedAddresses() {
            if (! this.form.newBillingAddress && this.form.billingAddressId) {
                this.form.billing = this.userAddresses[this.form.billingAddressId];
            }

            if (
                this.form.ship_to_a_different_address
                && ! this.form.newShippingAddress
                && this.form.shippingAddressId
            ) {
                this.form.shipping = this.userAddresses[this.form.shippingAddressId];
            }
        },

        changeBillingCity(city) {
            this.$set(this.form.billing, 'city', city);
        },

        changeShippingCity(city) {
            this.$set(this.form.shipping, 'city', city);
        },

        /*        
        changeBillingArea(area) {
            this.$set(this.form.billing, 'area', area);
        },

        changeShippingArea(area) {
            this.$set(this.form.shipping, 'area', area);
        },*/

        changeBillingZip(zip) {
            this.$set(this.form.billing, 'zip', zip);
        },

        changeShippingZip(zip) {
            this.$set(this.form.shipping, 'zip', zip);
        },

        changeBillingCountry(country, savedCity = false) {
            this.cities = {};
            /*            
            if(country == 253){
                $('.area-container').show();
            }
            else{
                $('.area-container').hide();
            }*/
            if(country > 0){
                
                this.loadingCityField = true;

                this.fetchCities(country, (fetchedData) => {
                    this.loadingCityField = false;
                    this.cities = fetchedData.cities;
                    let changeToCity = savedCity ? savedCity : this.firstCity;
                    this.changeBillingCity(changeToCity);
                });
            }
            else{
                this.changeBillingCity(0);
            }
        },

        changeShippingCountry(country, savedCity = false) {

            this.cities = {};

            if(country > 0){
                this.loadingCityField = true;
                this.fetchCities(country, (fetchedData) => {
                    this.loadingCityField = false;
                    this.cities = fetchedData.cities;
                    let changeToCity = savedCity ? savedCity : this.firstCity;
                    this.changeShippingCity(changeToCity)
                });
            }
            else{
                this.changeBillingCity(0);
            }
        },

        fetchCities(country_id, callback) {
            $.ajax({
                method: 'GET',
                url: route('countries.cities.index', { country_id: country_id }),
            }).then(callback);
        },

        /*        
        fetchAreas(city_id, callback) {
            $.ajax({
                method: 'GET',
                url: route('cities.areas.index', { city_id: city_id }),
            }).then(callback);
        },*/

        changePaymentMethod(paymentMethod) {
            this.$set(this.form, 'payment_method', paymentMethod);
        },

        changeShippingMethod(shippingMethodName) {
            this.$set(this.form, 'shipping_method', shippingMethodName);
            this.updateShippingFees();
            $("#collapsePaymentBtn").prop("disabled",false)
            $("#collapseCouponBtn").prop("disabled",false)
        },

        updatePaymentMethod() {
            if (this.form.payment_method != 'paypal') {
                $('.paypal-buttons').remove();
            }
            this.loadingPaymentBlock = true;
            this.loadingOrderSummary = true;
            $.ajax({
                method: 'POST',
                url: route('cart.payment_method.store'),
                data: this.form,
            }).then((cart) => {
                store.updateCart(cart);
                if (this.form.payment_method == 'payfort') {
                    this.renderPayfortElements();
                }
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loadingOrderSummary = false;
                this.loadingPaymentBlock = false;
            });
        },

        updateShippingFees() {
            this.loadingOrderSummary = true;

            $.ajax({
                method: 'POST',
                url: route('cart.update-shipping-fees'),
                data: this.form,
            }).then((cart) => {
                store.updateCart(cart);
                this.$set(this.form, 'shipping_method', cart.shippingMethodName);
                this.$delete(this.gateways, 'cod');
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loadingOrderSummary = false;
            });
        },

        updateShippingCostBasedOnAddress() {
            $.ajax({
                method: 'GET',
                url: route('cart.shipping-cost.update'),
                data: this.form,
            }).then((cart) => {
                store.updateCart(cart);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
            });
        },

        placeOrder() {
            if (this.placingOrder) {
                return;
            }

            this.placingOrder = true;

            $.ajax({
                method: 'POST',
                url: route('checkout.create'),
                data: this.form,
            }).then((response) => {
                if (response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                } else if (this.form.payment_method === 'stripe') {
                    this.confirmStripePayment(response);
                } else if (this.form.payment_method === 'payfort') {
                    this.confirmPayfortPayment(response);
                }  
                else if (this.form.payment_method === 'paytm') {
                    this.confirmPaytmPayment(response);
                } else if (this.form.payment_method === 'razorpay') {
                    this.confirmRazorpayPayment(response);
                } else {
                    this.confirmOrder(response.orderId, this.form.payment_method);
                }
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                }
                this.$notify(xhr.responseJSON.message);

                this.placingOrder = false;
            });
        },

        confirmOrder(orderId, paymentMethod, params = {}) {
            $.ajax({
                method: 'GET',
                url: route('checkout.complete.store', { orderId, paymentMethod, ...params }),
            }).then(() => {

                window.location.href = route('checkout.complete.show');

            }).catch((xhr) => {
                this.placingOrder = false;
                this.loadingOrderSummary = false;

                this.deleteOrder(orderId);
                this.$notify(xhr.responseJSON.message);
            });
        },

        deleteOrder(orderId) {
            if (! orderId) {
                return;
            }

            $.ajax({
                method: 'GET',
                url: route('checkout.payment_canceled.store', { orderId }),
            });
        },

        renderPayPalButton() {
            let vm = this;
            let response;

            window.paypal.Buttons({
                async createOrder() {
                    try {
                        response = await $.ajax({
                            method: 'POST',
                            url: route('checkout.create'),
                            data: vm.form,
                        });

                        return response.resourceId;
                    } catch (xhr) {
                        if (xhr.status === 422) {
                            vm.errors.record(xhr.responseJSON.errors);
                        } else {
                            vm.$notify(xhr.responseJSON.message);
                        }
                    }
                },
                onApprove() {
                    vm.loadingOrderSummary = true;

                    vm.confirmOrder(response.orderId, 'paypal', response);
                },
                onError() {
                    vm.deleteOrder(response.orderId);
                },
                onCancel() {
                    vm.deleteOrder(response.orderId);
                },
            }).render('#paypal-button-container');
        },

        renderStripeElements() {
            this.stripeCardElement = this.stripe.elements().create('card', {
                hidePostalCode: true,
            });

            this.stripeCardElement.mount('#stripe-card-element');
        },

        renderPayfortElements() {
            /*
            this.payfortCardElement = this.payfort.elements().create('card', {
                hidePostalCode: true,
            });*/
            if( $('#payfort-card-element').html()==""){ // if still not rendered
                this.loadingPaymentBlock = true;
                $.ajax({
                    method: 'GET',
                    url: route('checkout.payfort_generate_form'),
                }).done((response) => {
                    if (response.html) {
                        $('#payfort-card-element').html(response.html);
                        this.loadingPaymentBlock = false;

                        $('html, body').animate({
                            scrollTop: $('#payfort-card-element').offset().top
                        }, 800);
                    }
                }).fail((xhr) => {
                    this.placingOrder = false;
                    this.loadingOrderSummary = false;
                    this.loadingPaymentBlock = false;
                });
            }

            this.payfortCardElement.mount('#payfort-card-element');
        },

        async confirmStripePayment({ orderId, clientSecret }) {
            let result = await this.stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: this.stripeCardElement,
                    billing_details: {
                        email: this.form.customer_email,
                        name: `${this.form.billing.first_name} ${this.form.billing.last_name}`,
                        address: {
                            city: this.form.billing.city,
                            country: this.form.billing.country,
                            line1: this.form.billing.address_1,
                            line2: this.form.billing.address_2,
                            postal_code: this.form.billing.zip,
                        },
                    },
                },
            });

            if (result.error) {
                this.placingOrder = false;
                this.stripeError = result.error.message;

                this.deleteOrder(orderId);
            } else {
                this.confirmOrder(orderId, 'stripe', result);
            }
        },

        async confirmPayfortPayment({ orderId, clientSecret }) {
            var isValid = payfortFortMerchantPage2.validateCcForm();
            if(isValid) {
                getPaymentPage('cc_merchantpage2', orderId);
                return;
            }
            else{
                this.$sweetError(trans('storefront::checkout.please_fill_the_card_information_correctly'));
                this.placingOrder = false;
                this.loadingOrderSummary = false;
                this.loadingPaymentBlock = false;
            }
        },
        
        confirmPaytmPayment({ orderId, amount, txnToken }) {
            let config = {
                root: '',
                flow: 'DEFAULT',
                data: {
                    orderId: orderId,
                    token: txnToken,
                    tokenType: 'TXN_TOKEN',
                    amount: amount,
                },
                merchant: {
                    redirect: false,
                },
                handler: {
                    transactionStatus: (response) => {
                        if (response.STATUS === 'TXN_SUCCESS') {
                            this.confirmOrder(orderId, 'paytm', response);
                        } else if (response.STATUS === 'TXN_FAILURE') {
                            this.placingOrder = false;

                            this.deleteOrder(orderId);
                        }

                        window.Paytm.CheckoutJS.close();
                    },
                    notifyMerchant: (eventName) => {
                        if (eventName === 'APP_CLOSED') {
                            this.placingOrder = false;

                            this.deleteOrder(orderId);
                        }
                    },
                },
            };

            window.Paytm.CheckoutJS.init(config).then(() => {
                window.Paytm.CheckoutJS.invoke();
            }).catch(() => {
                this.deleteOrder(orderId);
            });
        },

        confirmRazorpayPayment(razorpayOrder) {
            this.placingOrder = false;

            let vm = this;

            new window.Razorpay({
                key: FleetCart.razorpayKeyId,
                name: FleetCart.storeName,
                description: `Payment for order #${razorpayOrder.receipt}`,
                image: FleetCart.storeLogo,
                order_id: razorpayOrder.id,
                handler(response) {
                    vm.placingOrder = true;

                    vm.confirmOrder(razorpayOrder.receipt, 'razorpay', response);
                },
                modal: {
                    ondismiss() {
                        vm.deleteOrder(razorpayOrder.receipt);
                    },
                },
                prefill: {
                    name: `${vm.form.billing.first_name} ${vm.form.billing.last_name}`,
                    email: vm.form.customer_email,
                    contact: vm.form.customer_phone,
                },
            }).open();
        },
    },
};
